import React from "react";

import { useTheme } from "../../context/ThemeContext";

import Image from "../../components/image";
import MiniInfoCard from "../../components/cards/miniInfoCard";

import PeopleBSC from "../../images/People__British_Standard.svg";
import PlanetBSC from "../../images/Planet_British_Standard.svg";

const ParentInfoIntroDetails = ({ parentInformationDetails }) => {
  const { colorMode } = useTheme();

  const participants =
    parentInformationDetails && parentInformationDetails.length
      ? parentInformationDetails?.map((parentInfo, index) => {
          return {
            id: index,
            title: parentInfo?.parentInfoDetailsTitle,
            logo: parentInfo?.parentInfoDetailsImage
          };
        })
      : [];

  if (participants?.length < 1) {
    return <></>;
  }

  const extraClasses = [
    "sm:col-span-3",
    "sm:col-span-2",
    "sm:col-span-4",
    "sm:col-span-4",
    "sm:col-span-5",
    "sm:col-span-6",
    "sm:col-span-4"
  ];
  return (
    <div className="flex flex-row w-full">
      <div className="flex flex-col py-4 w-full relative">
        <div className="w-full grid gap-x-0 gap-y-2 grid-cols-2 grid-rows-5 sm:gap-0 sm:grid-cols-none sm:grid-rows-none sm:justify-between sm:items-center sm:flex sm:py-4">
          <div className="col-start-1 row-start-1 col-span-2 row-span-full flex flex-wrap gap-x-2 sm:gap-x-3 sm:gap-y-4 items-center">
            {participants?.map((participant, i) => (
              <MiniInfoCard
                key={i}
                title={participant?.title}
                imageSourceUrl={participant?.logo?.sourceUrl}
                extraClass={"items-center"}
                imageClass="w-4 h-4 fill-black-lighter group-hover:fill-white planet:fill-white planet:group-hover:fill-black-lighter mr-2"
                descContainerClass={
                  "text-sm text-black-lighter planet:text-white"
                }
                textStyle={
                  "text-sm text-black-lighter planet:text-gray-generic planet:has-white-spans"
                }
              />
            ))}
          </div>

          <div className="col-start-2 row-start-4 row-span-full flex justify-end items-center sm:justify-center">
            <Image
              imageAlt={""}
              image={""}
              imageClass="w-2/3 h-full sm:w-40 grayscale"
              sourceUrl={colorMode === "light" ? PeopleBSC : PlanetBSC}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParentInfoIntroDetails;
